export const WhatChanges = ({ lines }: { lines: string[] }) => (
  <div>
    <p className="text-xs font-semibold text-neutral-600">What changes</p>
    <ul className="mt-1.5 space-y-1 text-sm text-neutral-900">
      {lines.map((line) => (
        <li key={line} className="flex gap-2">
          <span className="mt-2 size-1 shrink-0 rounded-full bg-neutral-500" />
          {line}
        </li>
      ))}
    </ul>
  </div>
)
